import axios from 'axios'

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_ADMIN_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
})

export default {
  setAccessToken (accessToken) {
    httpClient.defaults.headers = { Authorization: `Bearer ${accessToken}` }
  },
  async getCustomLabels (clientId) {
    try {
      const { data } = await httpClient.get(`/${clientId}/custom-labels`)
      return data
    } catch (e) {
      console.error(`Can't get custom labels. Error: ${e.message}`)
      throw new Error('Cannot get custom labels')
    }
  },
  async addCustomLabel (clientId, customLabel) {
    try {
      const { data } = await httpClient.post(`/${clientId}/new-custom-label`, customLabel)
      return data
    } catch (e) {
      console.error(`Can't save custom label. Error: ${e.message}`)
      throw new Error('Cannot save custom label')
    }
  },
  async updateCustomLabel (clientId, id, customLabel) {
    try {
      const { data } = await httpClient.post(`/${clientId}/custom-label/${id}/update`, customLabel)
      return data
    } catch (e) {
      console.error(`Can't save custom label. Error: ${e.message}`)
      throw new Error('Cannot save custom label')
    }
  },
  async deleteCustomLabel (clientId, id) {
    try {
      const { data } = await httpClient.post(`/${clientId}/custom-label/${id}/delete`)
      return data
    } catch (e) {
      console.error(`Can't delete custom label. Error: ${e.message}`)
      throw new Error('Cannot delete custom label')
    }
  }
}
